import { useFeatureFlag } from "./useFeatureFlag";

export const useIsMinimalBondUIEnabled = () => {
	const isExtractionEnabled = useFeatureFlag("bond_request_extraction");
	const isAiExtractionEnabled = useFeatureFlag("ai_bond_request_extraction");
	return isExtractionEnabled && isAiExtractionEnabled;
};
